import Vue from 'vue';
import Vuex from "vuex";
import shared from './modules/shared';
import worker from './modules/worker';
import team from './modules/team';
import car from './modules/car';
import user from './modules/user';

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        shared,
        worker,
        team,
        car,
        user
    }
});

export default store;
